// Convert a premium amount + term/mode string to an annualized figure.
// Examples:
//   annualizePremium(1000, 'Monthly')   -> 12000
//   annualizePremium(500, 'quarterly')  -> 2000
//   annualizePremium(750, '6 Month')    -> 1500
//   annualizePremium(2400, 'Annual')    -> 2400
//   annualizePremium(500, 'single')     -> 500    (single-pay, treat as annual)
//
// Recognizes: monthly, quarterly, semi-annual, 6 month, annual, 12 month,
// single. Falls through to "assume annual" for unknown terms.
export function annualizePremium(amount, term) {
  const n = Number(amount);
  if (!n || isNaN(n)) return 0;
  const t = String(term || '').toLowerCase().trim();
  if (!t) return n;
  if (t.includes('semi') || t === '6 month' || t === '6mo') return n * 2;
  if (t.includes('quarter') || t === 'qtr' || t === '3 month') return n * 4;
  if (t.includes('month') && !t.includes('6') && !t.includes('12')) return n * 12;
  // 'annual', '12 month', 'yearly', 'single', '1 year', or unknown -> assume already annual
  return n;
}
